<i18n locale="en">
{
  "title": "Publishing...",
  "description": "This will only take a moment"
}
</i18n>

<template>
  <div class="publish-in-progress align-center flex-col justify-center gap-3">
    <OwnProgressSpinner color="misc-brand" />
    <div class="align-center flex-col justify-center gap-1">
      <OwnType :text="t('title')" variant="title-large" />
      <OwnType :text="t('description')" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnProgressSpinner } from '@/ui/OwnProgressSpinner'
import { OwnType } from '@/ui/OwnType'

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.publish-in-progress {
  padding: 80px;
}
</style>
